import moment from 'moment'
import { toCamelCaseProperties } from '@/utils/fn';

export default class VisitBasic {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.appointmentId = args.appointmentId || args.timebokBesokId || null;
		this.chainId = args.chainId || 0;
		this.chainName = args.chainName || '';
		this.employeeId = args.employeeId || '';
		this.employeeImageUrl = args.employeeImageUrl || '';
		this.fixItSiteId = args.fixItSiteId || '';
		this.isHistoric = !!args.isHistoric;
		this.isRateable = !!(args.isRateable || args.canRate);
		this.rating = args.rating || 0;
		this.siteId = args.siteId || 0;
		this.siteName = args.siteName || '';
		this.visitId = args.visitId || '';
		this.dateAndTime = moment(args.dateAndTime || args.appointmentTime || '');
		this.visitIdUrlFriendly = args.visitIdUrlFriendly || '';
		this.urlFrendlyLink = args.urlFrendlyLink || '';
		this.webId = args.webId || '';
	}

	getRatingText() {
		return this.rating == 5 ? 'Knallbra.' : this.rating == 4 ? 'Bra.' : this.rating == 3 ? 'Greit.' : this.rating == 2 ? 'Dårlig.' : this.rating == 1 ? 'Elendig.' : '';
	}
}
